import "@omony/ui/styles.css";
import { ToastProvider } from "@omony/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { AppRoot } from "./AppRoot.js";
import { queryClient } from "./query.js";
import { registerServiceWorker } from "./sw.js";

export function mount(app: ReactNode, opts: { serviceWorker?: boolean } = {}) {
  const el = document.getElementById("root");
  if (!el) throw new Error("#root fehlt");
  createRoot(el).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppRoot>
          <ToastProvider>{app}</ToastProvider>
        </AppRoot>
      </QueryClientProvider>
    </StrictMode>,
  );
  if (opts.serviceWorker) registerServiceWorker();
}
